import { api_configuration, api_manifest } from "common";
import api_main = api_configuration.libraries.gui_definition_lib.types.main.alan_api;
import read_api_application = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import api_application_decorator = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import messages = require("./lib/front/messages");
import ClientState = require("./lib/state/ClientState");
import { engine_version, UNKNOWN_CLIENT_VERSION } from "./lib/state/ClientState";
import DestructorTree from "./lib/DestructorTree";
import openViewOnNode from "./lib/front/openViewOnNode";
import openLandingPage from "./lib/front/openLandingPage";
import { DatastoreConnection, DataStoreProtocolError, DatastoreProxy } from "./lib/interface/DatastoreProxy";
import { IdPathBuilder } from "./lib/navigation/IdPathBuilder";
import { authenticate, AuthenticationData } from "./lib/state 2 interface/authentication";
import { getFileFromWebServer, getFilesFromWebserver } from "./lib/state 2 interface/webserver";
import * as SourceMap from "source-map";
import clock from "./lib/state/clock";
import { decorate, DecoratedSchemas } from "./lib/state/schema";
import Window = require("./lib/widgets/dom/Window");
import hash = require("./lib/widgets/dom/hash");
import { initializeCollectionTable } from "./lib/state/CollationTable";
import { setupErrorHandlers } from "./lib/error-logging";
import * as deeplinkHandler from "./lib/front/deeplinkHandler";
import { translate } from "./lib/front/translate";
import { julian_datetime_2_js_date } from "./lib/calendar/conversion";

(<any>global) = window;
let package_fingerprint = "";

window.onload = () => {
	setupErrorHandlers((title, error_message) => {
		globalFailMessage(`${title}. ${error_message}`);
	});
	start();
};

(global as any).unexpectedState = function unexpectedState(state: never): never {
	throw new Error("Unexpected state '" + (<any>state).name + "'");
};

function resetModifierKeys() {
	ClientState.client_state.properties.alt_key_pressed.ensure("no", {});
	ClientState.client_state.properties.ctrl_key_pressed.ensure("no", {});
	ClientState.client_state.properties.shift_key_pressed.ensure("no", {});
	ClientState.client_state.properties.meta_key_pressed.ensure("no", {});
	ClientState.client_state.properties.toggle_key_pressed.ensure("no", {});
}

let root_destructor: DestructorTree | undefined = undefined;
let renderRoot: ((main: api_main.Cmain) => void) | undefined = (main: api_main.Cmain) => {
	if (root_destructor) {
		root_destructor.destroy();
	}
	document.body.innerHTML = "";
	const window_name = main.properties.root_window.ref.key;
	root_destructor = new DestructorTree();
	Window.initialize(
		window_name,
		() => document.body,
		root_destructor,
		ClientState.client_state.properties.windows.create(window_name, {
			"has active view": ["no", {}],
			"open views": {},
		})
	);
	openViewOnNode(IdPathBuilder.create(), main.properties.root_view.ref, main.properties.root_window.ref);
	switch (main.input.settings.properties.allow_deeplink.state.name) {
		case "yes": {
			const yes_allow_deeplink = main.input.settings.properties.allow_deeplink.state.node;
			if (window_name === yes_allow_deeplink.properties.target_window.ref.key) {
				deeplinkHandler.startListening(yes_allow_deeplink.properties.target_window.ref);
				root_destructor.onDestroy(deeplinkHandler.stopListening);
			}
			break;
		}
		case "no":
			break;
	}

	openLandingPage(ClientState.main);

	if (!window.navigator.onLine) {
		ClientState.client_state.properties.network_connection_status.set("dead", {});
		messages.addMessage("warning", "Check your internet connection.", { key: "NETWORK_CONNECTION_DOWN" });
	}
	window.ononline = function () {
		ClientState.client_state.properties.network_connection_status.set("alive", {});
		messages.removeMessage("NETWORK_CONNECTION_DOWN");
	};
	window.onoffline = function () {
		ClientState.client_state.properties.network_connection_status.set("dead", {});
		messages.addMessage("warning", "Check your internet connection.", { key: "NETWORK_CONNECTION_DOWN" });
	};

	window.addEventListener("keydown", handleModifierKeys);
	window.addEventListener("keyup", resetModifierKeys);
	window.addEventListener("blur", resetModifierKeys);
	window.addEventListener("focus", resetModifierKeys);

	window.onbeforeunload = () => {
		switch (ClientState.client_state.properties.root.properties.modified.state.name) {
			case "no": {
				return undefined;
			}
			case "yes": {
				return true;
			}
			default:
				unexpectedState(ClientState.client_state.properties.root.properties.modified.state);
		}
	};
};

function handleModifierKeys(event: KeyboardEvent) {
	if (event.altKey) {
		ClientState.client_state.properties.alt_key_pressed.ensure("yes", {});
	}
	if (event.ctrlKey) {
		ClientState.client_state.properties.ctrl_key_pressed.ensure("yes", {});
	}
	if (event.shiftKey) {
		ClientState.client_state.properties.shift_key_pressed.ensure("yes", {});
	}
	if (event.metaKey) {
		ClientState.client_state.properties.meta_key_pressed.ensure("yes", {});
	}
	ClientState.client_state.properties.platform_family.switch({
		Android: () => {
			ClientState.client_state.properties.ctrl_key_pressed.switch({
				no: undefined,
				yes: () => {
					ClientState.client_state.properties.toggle_key_pressed.ensure("yes", {});
				},
			});
		},
		Linux: () => {
			ClientState.client_state.properties.ctrl_key_pressed.switch({
				no: undefined,
				yes: () => {
					ClientState.client_state.properties.toggle_key_pressed.ensure("yes", {});
				},
			});
		},
		Windows: () => {
			ClientState.client_state.properties.ctrl_key_pressed.switch({
				no: undefined,
				yes: () => {
					ClientState.client_state.properties.toggle_key_pressed.ensure("yes", {});
				},
			});
		},
		iOS: () => {
			ClientState.client_state.properties.alt_key_pressed.switch({
				no: undefined,
				yes: () => {
					ClientState.client_state.properties.toggle_key_pressed.ensure("yes", {});
				},
			});
		},
		macOS: () => {
			ClientState.client_state.properties.alt_key_pressed.switch({
				no: undefined,
				yes: () => {
					ClientState.client_state.properties.toggle_key_pressed.ensure("yes", {});
				},
			});
		},
		undetermined: () => {
			ClientState.client_state.properties.ctrl_key_pressed.switch({
				no: undefined,
				yes: () => {
					ClientState.client_state.properties.toggle_key_pressed.ensure("yes", {});
				},
			});
		},
	});
}

function globalFailMessage(message: string) {
	if (DatastoreProxy.instance) {
		DatastoreProxy.instance.connection.disconnectWebSocket();
	}
	stopSynchronizingServerTime();
	renderRoot = undefined;

	window.ononline = null;
	window.onoffline = null;
	window.onbeforeunload = null;
	window.removeEventListener("keydown", handleModifierKeys);
	window.removeEventListener("keyup", resetModifierKeys);
	window.removeEventListener("blur", resetModifierKeys);
	window.removeEventListener("focus", resetModifierKeys);

	if (ClientState.main) {
		ClientState.main.input.settings.properties.settings.properties.reload_on_unexpected_error.switch({
			enabled: function () {
				window.location.reload();
			},
			disabled: function () {
				document.title = "Warning";
				document.body.innerHTML =
					'<div id="engine-global-message">' +
					message +
					"&nbsp;<button onclick='window.location.reload()'>Refresh</button></div>";
			},
		});
	} else {
		document.title = "Warning";
		document.body.innerHTML =
			'<div id="engine-global-message">' +
			message +
			"&nbsp;<button onclick='window.location.reload()'>Refresh</button></div>";
	}
	global.errorCaughtAndSent = true; // do not report errors anymore
}

function globalMessage(message: string) {
	document.body.innerHTML =
		'<div id="engine-global-message">' +
		message +
		"&nbsp;<button onclick='window.location.reload()'>Refresh</button></div>";
}

async function synchronizeServerTime(connection: DatastoreConnection) {
	const julian_time = await connection.getServerTime();
	const synchronization_time = Date.now();
	clock.setNowFunction(function () {
		return julian_time + Math.round((Date.now() - synchronization_time) / 1000);
	});
}

let serverTimeInterval: number | undefined = undefined;
function startSynchronizingServerTime(connection: DatastoreConnection) {
	const sync = () => {
		synchronizeServerTime(connection);
	};
	serverTimeInterval = setInterval(sync, 60 * 1000);
}
function stopSynchronizingServerTime() {
	if (serverTimeInterval) {
		clearInterval(serverTimeInterval);
	}
}

global.sourceMapper = () => "<uninitialized>";

function initializeSourceMapper() {
	if (global.alan_debug) {
		fetch("engine/main.js")
			.then((response) => response.text())
			.then((source) => {
				// split the string so that it itself is not matched in the source code
				const sourceMappingURL = source.split("source" + "Mapping" + "URL=")[1];
				let decodedSource: string;
				try {
					const supportedEncodingRegexp = /^data:application\/json;([\w=:"-]+;)*base64,/;
					const match = sourceMappingURL.match(supportedEncodingRegexp);
					const sourceMapStart = match![0].length;
					const encodedSource = sourceMappingURL.substr(sourceMapStart);
					decodedSource = window.atob(encodedSource);
				} catch (e) {
					return;
				}
				const sourceMapConsumer = new SourceMap.SourceMapConsumer(decodedSource as any);
				global.sourceMapper = (lineNumber: number, columnNumber: number) => {
					const location = sourceMapConsumer.originalPositionFor({
						line: lineNumber,
						column: columnNumber,
					});
					if (location.source) {
						return `${location.source}:${location.line}:${location.column}`;
					}
					return "<failed>";
				};
			});
	}
}

async function start() {
	global.file_storage_url = "../platform_filesresource/";

	rewriteUrlParameters();
	global.alan_debug = hash.getDebug();
	initializeSourceMapper();
	try {
		await checkEngineVersion();
		const datastore_connection = new DatastoreConnection(undefined);
		const application_name = await getApplicationName();
		const authentication_data = await authenticate(application_name, datastore_connection);
		if (authentication_data !== undefined) {
			datastore_connection.token = authentication_data.token;
		}
		const devserver_port = hash.getDevserverPort();
		if (devserver_port !== null) {
			hash.clearDevserverPort();
			const url = new URL("http://localhost");
			url.port = devserver_port;
			url.pathname = "/client/";
			const params = new URLSearchParams(window.location.hash.slice(1));
			if (authentication_data !== undefined) {
				params.set("u", authentication_data.username);
				params.set("t", authentication_data.token);
			}
			url.hash = params.toString();
			window.location.href = url.toString();
			return;
		}

		const raw_manifest = await getFileFromWebServer("gui_definition/.manifest", JSON.parse);
		const manifest = api_manifest.initialize(raw_manifest, "gui_definition/");

		await Promise.all([
			getFilesFromWebserver(
				[
					manifest.root["main.alan"].path,
					manifest.root["settings.alan"].path,
					manifest.root["phrases.alan"].path,
					manifest.root["model.alan"].path,
					manifest.root["model"]["application.alan"].path,
					manifest.root["client.lib"]["client_bindings.alan"].path,
				],
				JSON.parse
			).then(async (result) => {
				const application_model = api_application_decorator.Capplication.create(
					result[manifest.root["model"]["application.alan"].path]
				);
				package_fingerprint = manifest.fingerprint;
				const views_to_get = Object.entries(manifest.root.views).map((value) => value[1].path);
				const translations_to_get = Object.entries(manifest.root.translations).map((value) => value[1].path);
				const widgets_to_get = Object.entries(manifest.root.widgets).map((value) => value[1].path);
				const controls_to_get = Object.entries(manifest.root["control-bundle.lib"]["controls.lib"].controls).map(
					(value) => value[1]["control.alan"].path
				);
				global.control_media_directory = "gui_definition/package/control-bundle.lib/package/controls.lib/package/media";

				const control_implementations = Object.entries(manifest.root["control-bundle.lib"])
					.filter((file) => /\.js$/.test(file[0]))
					.map((value) => (value[1] as api_manifest.ManifestFile).path);
				const control_styles = Object.entries(manifest.root["control-bundle.lib"])
					.filter((file) => /\.css$/.test(file[0]))
					.map((value) => (value[1] as api_manifest.ManifestFile).path);
				const reports_to_get = Object.entries(manifest.root.reports).map((value) => value[1]["parameters.alan"].path);
				await Promise.all(
					control_styles.map(
						(css_path) =>
							new Promise<void>((resolve) => {
								const link = document.createElement("link");
								link.type = "text/css";
								link.rel = "stylesheet";
								link.href = css_path;
								link.onload = () => resolve();
								document.head.append(link);
							})
					)
				);
				await Promise.all(
					control_implementations.map(
						(script_source) =>
							new Promise<void>((resolve) => {
								// Load the control implementations later than the stylesheets to prevent weird
								// style and font artifacts.
								const script = document.createElement("script");
								script.type = "text/javascript";
								script.src = script_source;
								script.onload = () => resolve();
								document.head.append(script);
							})
					)
				);
				const additional_file_result = await getFilesFromWebserver(
					views_to_get
						.concat(translations_to_get)
						.concat(widgets_to_get)
						.concat(controls_to_get)
						.concat(reports_to_get),
					JSON.parse
				);
				initializeClientState(
					decorate(
						{
							gui_model: result[manifest.root["model.alan"].path],
							widgets: Object.entries(manifest.root.widgets).reduce<Record<string, any>>((result, [key, file]) => {
								result[key] = additional_file_result[file.path];
								return result;
							}, {}),
							main: result[manifest.root["main.alan"].path],
							phrases: result[manifest.root["phrases.alan"].path],
							settings: result[manifest.root["settings.alan"].path],
							client_bindings: result[manifest.root["client.lib"]["client_bindings.alan"].path],
							controls: Object.entries(manifest.root["control-bundle.lib"]["controls.lib"].controls).reduce<
								Record<string, any>
							>(function (c, [control_name, file]) {
								c[control_name] = additional_file_result[file["control.alan"].path];
								return c;
							}, {}),
							views: Object.entries(manifest.root.views).reduce<Record<string, any>>(function (v, [view_name, file]) {
								v[view_name] = additional_file_result[file.path];
								return v;
							}, {}),
							reports: Object.entries(manifest.root.reports).reduce<Record<string, any>>(function (
								r,
								[report_name, file]
							) {
								r[report_name] = additional_file_result[file["parameters.alan"].path];
								return r;
							},
							{}),
							translations: Object.entries(manifest.root.translations).reduce<Record<string, any>>(function (
								t,
								[translation_name, file]
							) {
								t[translation_name] = additional_file_result[file.path];
								return t;
							},
							{}),
						},
						application_model
					)
				);
				if (authentication_data !== undefined) {
					const uri = await datastore_connection.getAuthenticationUri();
					const request = new XMLHttpRequest();
					const appendSlash = (text: string) => text + (text.charAt(text.length - 1) === "/" ? "" : "/");
					request.open("POST", appendSlash(uri) + "request");
					request.setRequestHeader("Content-Type", "application/json");
					request.onload = () => {
						if (request.status === 200) {
							const reponse_message: {
								type: [
									"known uris",
									{
										uris: {
											[key: string]: { name: string };
										};
									}
								];
							} = JSON.parse(request.responseText);
							const uris = reponse_message.type[1].uris;
							const sorted_uris = Object.keys(reponse_message.type[1].uris)
								.map((key) => ({
									name: uris[key].name,
									url: key,
								}))
								.sort((a, b) => a.name.localeCompare(b.name));
							sorted_uris.forEach((uri) => {
								if (appendSlash(uri.url) !== appendSlash(window.location.origin + window.location.pathname)) {
									const new_module = ClientState.client_state.properties.modules.create(uri.url, {
										name: uri.name,
										"has logo": "no",
									});
									const logo_request = new XMLHttpRequest();
									const logo_url = appendSlash(uri.url) + "data/logo.png";
									logo_request.open("GET", logo_url);
									logo_request.onload = () => {
										if (logo_request.status === 200) {
											new_module.properties.has_logo.set("yes", {
												url: logo_url,
											});
										}
									};
									logo_request.send();
								}
							});
						}
					};
					request.send(
						JSON.stringify({
							type: [
								"known uris",
								{
									token: authentication_data.token,
								},
							],
						})
					);
				}
				const data_manifest = await getFileFromWebServer("data/.manifest");
				const files = data_manifest.split("\n").filter((f) => f.length > 1);
				const handlers: Record<string, (name: string) => void | Promise<void>> = {
					"logo.png": (name) => {
						ClientState.client_state.set_logo_url("data/" + name);
					},
					"logo-sideways.png": (name) => {
						ClientState.client_state.set_logo_sideways_url("data/" + name);
					},
					"config.json": (name) =>
						getFileFromWebServer("data/" + name, JSON.parse).then((config) => {
							if (config["include data in error log"]) {
								global.logClientStateOnError = true;
							}
						}),
				};
				await Promise.all(files.map((file) => handlers[file](file)));
				initializeDataStoreProxy(application_model, authentication_data, datastore_connection);
			}),
			(async () => {
				const raw_collation_table = await getFileFromWebServer(
					manifest.root["collation_table.alan.json"].path,
					JSON.parse
				);
				initializeCollectionTable(raw_collation_table);
			})(),
		]);
	} catch (e) {
		if (e instanceof DataStoreProtocolError) {
			globalMessage("Could not connect to the datastore. Please wait, we will try again.");
			setTimeout(() => {
				start();
			}, 1000);
		}
		if (typeof e === "string") {
			globalFailMessage("The application could not be loaded. Refresh to try again.");
		} else {
			throw e;
		}
	}
}

async function getApplicationName(): Promise<string> {
	if (ClientState.settings) {
		const application_name_phrase = ClientState.settings.properties.settings.properties.application_name.entry;
		return Promise.resolve(
			ClientState.client_state.properties.selected_language.ref.key.ref.properties.translations.get(
				application_name_phrase
			)!.properties.translation
		);
	}
	const raw_settings = await getFileFromWebServer("gui_definition/package/settings.alan.json", JSON.parse);
	return raw_settings.settings["application name"];
}

function initializeClientState(schemas: DecoratedSchemas) {
	ClientState.initialize(schemas);
	const hash_language = hash.getLanguage();
	if (hash_language !== null) {
		hash.clearLanguage();
	}
	const lang_initialization_value = hash_language ?? window.localStorage.getItem("language");
	if (
		lang_initialization_value &&
		ClientState.main.input.settings.input.languages[lang_initialization_value] !== undefined
	) {
		ClientState.client_state.set_selected_language(lang_initialization_value);
	}

	function platformMatch(platform: string) {
		if (navigator.platform.toLowerCase().search(platform) !== -1) {
			return true;
		} else {
			return false;
		}
	}
	if (platformMatch("mac")) {
		ClientState.client_state.properties.platform_family.set("macOS", {});
	} else if (platformMatch("ipad") || platformMatch("iphone")) {
		ClientState.client_state.properties.platform_family.set("iOS", {});
	} else if (platformMatch("linux")) {
		ClientState.client_state.properties.platform_family.set("Linux", {});
	} else if (platformMatch("android")) {
		ClientState.client_state.properties.platform_family.set("Android", {});
	} else if (platformMatch("win")) {
		ClientState.client_state.properties.platform_family.set("Windows", {});
	} else {
		ClientState.client_state.properties.platform_family.set("undetermined", {});
	}

	function browserMatch(browser: string) {
		if (navigator.userAgent.toLowerCase().search(browser) !== -1) {
			return true;
		} else {
			return false;
		}
	}
	if (browserMatch("edge")) {
		ClientState.client_state.properties.browser_family.set("Edge", {});
	} else if (browserMatch("safari") && !browserMatch("chrome")) {
		ClientState.client_state.properties.browser_family.set("Safari", {});
	} else if (browserMatch("chrome")) {
		ClientState.client_state.properties.browser_family.set("Chromium", {});
	} else {
		ClientState.client_state.properties.browser_family.set("undetermined", {});
	}

	ClientState.client_state.set_version(engine_version.trim());
	ClientState.client_state.subscribe_selected_language({
		on_update: function () {
			document.documentElement.lang = ClientState.client_state.properties.selected_language.entry.substr(
				0,
				ClientState.client_state.properties.selected_language.entry.indexOf(".")
			);
			document.title = ClientState.client_state.properties.selected_language.ref.key.ref.properties.translations.get(
				ClientState.main.input.settings.properties.settings.properties.application_name.entry
			)!.properties.translation;
			window.localStorage.setItem("language", ClientState.client_state.properties.selected_language.entry);
		},
	});
	ClientState.settings.properties.settings.properties.content_selection.switch({
		enabled: function () {
			document.body.classList.remove("engine-content-selection-disabled");
		},
		disabled: function () {
			document.body.classList.add("engine-content-selection-disabled");
		},
	});
	if (hash.getUpdated() !== null) {
		messages.addMessage("success", "The application is updated");
		hash.clearUpdated();
	}
}

export function initializeDataStoreProxy(
	application_model: read_api_application.Capplication,
	authentication_data: AuthenticationData | undefined,
	connection: DatastoreConnection
) {
	if (DatastoreProxy.instance) {
		(DatastoreProxy.instance as any) = null;
	}
	DatastoreProxy.instance = new DatastoreProxy(application_model, connection);
	DatastoreProxy.instance
		.on("connect", () => {
			startSynchronizingServerTime(connection);
			clearWindowsFromClientState();
			setAuthenticationStatus(authentication_data, connection);
			renderRoot?.(ClientState.main);
			window.onunload = function () {
				DatastoreProxy.instance.unSubscribeAll();
			};
		})
		.on("reconnect", () => {
			ClientState.client_state.properties.server_connection_status.set("alive", {});
			messages.removeMessage("SERVER_DISCONNECTED");
			startSynchronizingServerTime(connection);

			getFilesFromWebserver(["gui_definition/.manifest", "engine/version.txt"])
				.then((result) => {
					if (
						package_fingerprint !== JSON.parse(result["gui_definition/.manifest"]).fingerprint ||
						engine_version !== result["engine/version.txt"]
					) {
						deeplinkHandler.stopListening();
						hash.setUpdated();
						const hash_before_destroy = window.location.hash;
						root_destructor?.destroy();
						window.location.hash = hash_before_destroy;
						window.location.reload();
					}
				})
				.catch((e) => {
					if (typeof e === "string") {
						globalFailMessage("The application could not be loaded. Refresh to try again.");
					}
				});
		})
		.on("disconnect", () => {
			ClientState.client_state.properties.server_connection_status.set("dead", {});
			stopSynchronizingServerTime();
			messages.addMessage("waiting", "Performing maintenance, please wait…", { key: "SERVER_DISCONNECTED" });
		})
		.on("invalid token", async () => {
			stopSynchronizingServerTime();
			const application_name = await getApplicationName();
			const authentication_data = await authenticate(application_name, DatastoreProxy.instance.connection);
			setAuthenticationStatus(authentication_data, connection);
		})
		.on_announcement((message) => {
			messages.addMessage("success", "Server announcement", {
				raw_body: parseServerAnnouncement(message),
			});
		});
}

function parseServerAnnouncement(message: string) {
	try {
		const parsed_message: {
			message: ["unstructured", { text: string }] | ["maintenance", { at: number }];
		} = JSON.parse(message);
		switch (parsed_message.message[0]) {
			case "unstructured":
				return parsed_message.message[1].text ?? message;
			case "maintenance": {
				const timestamp = parsed_message.message[1].at;
				if (timestamp !== undefined) {
					return translate("Updated scheduled") + " " + julian_datetime_2_js_date(timestamp).toString();
				}
				return message;
			}
		}
	} catch (e) {
		return message;
	}
}

function setAuthenticationStatus(authentication_data: AuthenticationData | undefined, connection: DatastoreConnection) {
	if (authentication_data !== undefined) {
		connection.token = authentication_data.token;
	}
	if (connection.token) {
		ClientState.client_state.properties.session.properties.status.set("authenticated", {
			token: connection.token,
			"anonymous session": [
				"no",
				{
					username: authentication_data?.username ?? "",
					"user found": ["no", {}],
				},
			],
		});
	} else {
		ClientState.client_state.properties.session.properties.status.set("authenticated", {
			token: "",
			"anonymous session": ["yes", {}],
		});
	}
}

async function checkEngineVersion(): Promise<void> {
	const result = await getFilesFromWebserver(["engine/version.txt"]);
	if (engine_version === UNKNOWN_CLIENT_VERSION) {
		ClientState.engine_version = result["engine/version.txt"];
	} else if (engine_version !== result["engine/version.txt"]) {
		globalFailMessage("A new version is available. Refresh to continue.");
		throw new Error("Newer engine is available.");
	}
}

function clearWindowsFromClientState() {
	if (ClientState.client_state) {
		ClientState.client_state.transact(() => {
			const attributes = ClientState.client_state.properties.root.properties.attributes;
			for (const [name] of attributes.entries()) {
				attributes.delete(name);
			}
			const root_queries = ClientState.client_state.properties.root.properties.queries;
			for (const [name] of root_queries) {
				root_queries.delete(name);
			}
			ClientState.client_state.properties.windows.forEach(($) => {
				Window.getWindowInstance($.key.entry).destructor.destroy();
			});
		});
	}
}

function rewriteUrlParameters() {
	const search_params = new URLSearchParams(window.location.hash.substring(1));
	const serialized_parameters = search_params.get("parameters");
	if (serialized_parameters) {
		search_params.delete("parameters");
		let deserialized_parameters = "";
		try {
			deserialized_parameters = atob(serialized_parameters);
		} catch (
			e
			// eslint-disable-next-line no-empty
		) {}
		if (deserialized_parameters) {
			const orginal_seach_params = new URLSearchParams(deserialized_parameters);
			for (const entry of orginal_seach_params) {
				if (entry[0] !== "parameters") {
					search_params.append(entry[0], entry[1]);
				}
			}
		}
		const url = new URL(window.location.href);
		url.hash = search_params.toString();
		window.location.replace(url.toString());
	}
}
